module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-hashtag"
  }, [_c('div', {
    class: _vm.waitingResponseFromAPI ? 'content waiting' : 'content'
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Insert your hashtag")]), _vm._v(" "), _c('div', {
    staticClass: "select-your-hashtag"
  }, [_c('div', {
    staticClass: "search-hashtag"
  }, [_c('p', {
    staticClass: "hashtag-input"
  }, [_c('span', {
    on: {
      "click": _vm.focusToInput
    }
  }, [_vm._v("#")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userHashtag),
      expression: "userHashtag"
    }],
    style: (_vm.inputWidthStyle),
    attrs: {
      "type": "text",
      "id": "hashtaginput",
      "name": "hashtag",
      "tabindex": "-1",
      "maxlength": _vm.inputMaxLength,
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.userHashtag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userHashtag = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "start",
      "disabled": !_vm.isHashtag
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Let's start!")])])]), _vm._v(" "), _c('div', {
    class: _vm.requestError.show ? 'request-error show' : 'request-error'
  }, [_c('p', [_vm._v(_vm._s(_vm.requestError.message))])]), _vm._v(" "), _c('preloader', {
    attrs: {
      "display": _vm.isLoading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/logo/logo-white.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-da0787ee!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Hashtag.vue
// module id = 188
// module chunks = 2